import { Component, OnInit, ViewEncapsulation, ViewChild, Inject } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { fuseAnimations } from '../../../../../../../../../../core/animations';
import * as _ from 'lodash';
//Service files
import { SideNavService } from '../../../../sidenav.service';

//Common components
import { ToastComponent } from '../../../../../../../common/toast.component';

//Common values and models files
import { BytheFootSection, toolTip, kpiDisplayValues } from '../../../../../../../utils';
import { FetchAllKpiValues, KpiDataSets, kpiAllDataSets } from '../../../../../../../models';

@Component({
  selector: 'spekwo-kpi-form-view',
  templateUrl: './kpi-form-view.component.html',
  styleUrls: ['./kpi-form-view.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class KpiFormViewComponent implements OnInit {

  displayValues = kpiDisplayValues;
  nameValues = BytheFootSection;
  toolTip = toolTip;

  currentDate: Date = new Date();
  currentMonth: number;
  currentMonthString: string;
  currentYr: number;
  selectedMonth: number;
  monthNames: string[] = kpiDisplayValues.spekwoKpi.monthNames;
  formLoader: boolean = false;
  kpiId: number;

  currentMonthKpiValues: KpiDataSets = Object.assign({}, initialData);
  allKpiDataDetails: kpiAllDataSets = Object.assign({}, initialKpiDataSet);

  isKPIUpdated: Observable<boolean>;
  private _subscriptions: Subscription[] = [];


  public data: any[][] = [];

  constructor(
    /** Local component */
    private toastComponent: ToastComponent,
    private _SideNavService: SideNavService,
  ) { this.isKPIUpdated = this._SideNavService.onKpiDetailsChanged.asObservable(); }

  ngOnInit() {

    //Subscription to watch any changes happen in kpi values
    this._subscriptions.push(
      this._SideNavService.onKpiDetailsChanged.subscribe(response => {
        this.formLoader = true;
        this.getAllKpiValues(response);
      }, () => {
        this.formLoader = false;

      })
    );

    //Getting current month && year
    this.currentMonth = this.currentDate.getMonth();
    this.currentMonthString = this.monthNames[this.currentMonth];
    this.currentYr = this.currentDate.getFullYear();
    this.selectedMonth = this.currentMonth;
    this.formLoader = true;
  }

  ngOnDestroy() {
    this._subscriptions.forEach(subscriptions => subscriptions.unsubscribe());
  }

  //To fetch all kpi values
  getAllKpiValues(allKpiData) {

    this.data = [];
    if (allKpiData) {
      //Assigning all kpi values to local variable
      this.allKpiDataDetails.kpiDetails = Object.assign([], allKpiData.allKpiList);
      this.kpiId = allKpiData.kpiId;

    }

    var index: number;
    //To fecth index of current month
    index = this.fectchingSelectedMonthIndex();
    //Assigning current month values to local variable
    this.currentMonthKpiValues = Object.assign({}, this.allKpiDataDetails.kpiDetails[index]);

    this.formLoader = false;

  }

  fectchingSelectedMonthIndex(): number {
    var index: number = null;
    var month = this.currentMonth;
    var curyear = this.currentYr;
    var matchQuery = _.findIndex(this.allKpiDataDetails.kpiDetails, { 'month': month, 'year': curyear });
    //To Get a current month data values
    index = (matchQuery >= 0) ? matchQuery : index;
    return index;

  }

  //To fetch a selected month kpi values 
  fetchSelectedMonthKpi(resquetedMonth: number) {

    var index;

    //To fecth index of current month
    index = this.fectchingSelectedMonthIndex();
    //Assigning updated values to current month kpi values
    this.allKpiDataDetails.kpiDetails[index] = (index >= 0) ? Object.assign({}, this.currentMonthKpiValues)
      : this.allKpiDataDetails.kpiDetails[index];

    index = null;
    this.currentMonth = (resquetedMonth > 11 || resquetedMonth < 0) ?
      (resquetedMonth > 11) ? 0 : 11 : resquetedMonth;
    this.currentYr = (resquetedMonth > 11 || resquetedMonth < 0) ?
      (resquetedMonth > 11) ? (this.currentYr + 1) : (this.currentYr - 1) : this.currentYr;
    this.currentMonthString = this.monthNames[this.currentMonth];

    //To fecth index of current month
    index = this.fectchingSelectedMonthIndex();
    //Assigning updated values to current month kpi values
    this.currentMonthKpiValues = (index == null) ? Object.assign({}, initialData)
      : Object.assign({}, this.allKpiDataDetails.kpiDetails[index]);

  }

  onGrossRevCalulation(event) {
    this.currentMonthKpiValues.fullSpekwo.grossRev = this.currentMonthKpiValues.fullSpekwo.total *
      this.currentMonthKpiValues.fullSpekwo.itemRev;
    this.currentMonthKpiValues.spekCall.grossRev = this.currentMonthKpiValues.spekCall.total *
      this.currentMonthKpiValues.spekCall.itemRev;
    this.currentMonthKpiValues.spekWalk.grossRev = this.currentMonthKpiValues.spekWalk.total *
      this.currentMonthKpiValues.spekWalk.itemRev;
    this.currentMonthKpiValues.spekApproved.grossRev = this.currentMonthKpiValues.spekApproved.total *
      this.currentMonthKpiValues.spekApproved.itemRev;
    this.currentMonthKpiValues.revenueForSpekPro.grossRev = this.currentMonthKpiValues.revenueForSpekPro.total *
      this.currentMonthKpiValues.revenueForSpekPro.itemRev;
  }

  //On save funcitonality
  onKpiSave() {

    this.formLoader = true;
    var index;

    //To fecth index of current month
    index = this.fectchingSelectedMonthIndex();

    //Assigning updated values to current month kpi values
    this.allKpiDataDetails.kpiDetails[index] = Object.assign({}, this.currentMonthKpiValues);

    //Calling updating service function
    this._SideNavService.updateKpiDetailsById(this.allKpiDataDetails, this.kpiId).then((res) => {
      if (res) {
        this.toastComponent.showToast('Values are saved successfully');
        //To get a updated values
        this.formLoader = false;
        this._SideNavService.fetchAllKpiData().then((response: FetchAllKpiValues) => { });
      }
    }, (err) => {
      this.formLoader = false;
      console.log(err);
    });
  }

  //Create functionality
  createNewKpiSet() {

    //Calling updating service function
    this._SideNavService.CreateKpiDetails(this.allKpiDataDetails).then((res) => {
      console.log("response", res);
      if (res) {
        this.toastComponent.showToast('Values are saved successfully');
        //To get a updated values
        this.formLoader = false;
        // this.getAllKpiValues();
      }
    }, (err) => {
      this.formLoader = false;
      console.log(err);
    });
  }

}

const initialData: KpiDataSets = {
  fullSpekwo: {
    total: 0,
    itemRev: 0.00,
    grossRev: 0.00
  },
  spekCall: {
    total: 0,
    itemRev: 0.00,
    grossRev: 0.00
  },
  spekWalk: {
    total: 0,
    itemRev: 0.00,
    grossRev: 0.00
  },
  spekApproved: {
    total: 0,
    itemRev: 0.00,
    grossRev: 0.00
  },
  revenueForSpekPro: {
    total: 0,
    itemRev: 0.00,
    grossRev: 0.00
  },
  revenueForSpekInternalPro: 0.00,
  numberOfOutBoundCalls: 0,
  numberOfEmailCampaigns: 0,
  amtSpentLivePresent: 0.00,
  amtSpentFb: 0.00,
  amtSpentInsta: 0.00,
  amtSpentLinkedIn: 0.00,
  date: new Date(),
  month: null,
  year: null
}

const initialKpiDataSet: kpiAllDataSets = {
  kpiDetails: []
}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/sidenavs/left/operations/kpi/kpi-form-view/kpi-form-view.component.ts